import React from 'react';
import './SavedColleges.css';

function SavedColleges({ savedColleges, isOpen, onToggle, onRemoveFromSaved }) {
  // Group schools by category for counts
  const reachCount = savedColleges.filter(s => s.category === 'reach').length;
  const targetCount = savedColleges.filter(s => s.category === 'target').length;
  const safetyCount = savedColleges.filter(s => s.category === 'safety').length;

  // Sort schools: Reach -> Target -> Safety -> Unknown
  const categoryOrder = { 'reach': 1, 'target': 2, 'safety': 3, 'unknown': 4 };
  
  const sortedSchools = [...savedColleges].sort((a, b) => {
    const catA = a.category || 'unknown';
    const catB = b.category || 'unknown';
    return (categoryOrder[catA] || 4) - (categoryOrder[catB] || 4);
  });

  const getChanceColorClass = (chance) => {
    if (!chance) return '';
    if (chance >= 70) return 'chance-high';
    if (chance >= 30) return 'chance-med';
    return 'chance-low';
  };

  const getChangeClass = (oldChance, newChance) => {
    if (newChance > oldChance) return 'chance-improved';
    if (newChance < oldChance) return 'chance-declined';
    return '';
  };

  return (
    <section id="saved-colleges" className="report-section saved-colleges-section">
      <div className="section-header" onClick={onToggle}>
        <h2>
          My Saved Colleges
          {savedColleges.length > 0 && <span className="count-badge">{savedColleges.length}</span>}
        </h2>
        <button className="accordion-toggle">
          {isOpen ? '▼' : '▶'}
        </button>
      </div>

      {isOpen && (
        <div className="section-content">
          {savedColleges.length === 0 ? (
            <p className="recommendations-intro">
              You haven't saved any colleges yet. Click the heart icon on any school card to add it here!
            </p>
          ) : (
            <>
              {/* Dashboard Summary */}
              <div className="saved-dashboard">
                <div className="dashboard-card reach">
                  <span className="dashboard-count">{reachCount}</span>
                  <span className="dashboard-label">Reach</span>
                </div>
                <div className="dashboard-card target">
                  <span className="dashboard-count">{targetCount}</span>
                  <span className="dashboard-label">Target</span>
                </div>
                <div className="dashboard-card safety">
                  <span className="dashboard-count">{safetyCount}</span>
                  <span className="dashboard-label">Safety</span>
                </div>
              </div>

              {/* Compact List View */}
              <div className="saved-list-container">
                <div className="saved-list-header">
                  <div className="header-school">School</div>
                  <div className="header-category">Category</div>
                  <div className="header-chance">Your Chance</div>
                  <div className="header-acceptance">Acceptance Rate</div>
                  <div className="header-actions">Actions</div>
                </div>
                
                {sortedSchools.map(school => {
                  const linkUrl = school.prepscholar_url || school.url;

                  return (
                    <div key={school.id} className="saved-list-item">
                      <div className="school-info">
                        <div className="list-school-name">{school.name}</div>
                        <div className="list-school-location">{school.city}, {school.state}</div>
                      </div>
                      
                      <div>
                        <span className={`list-badge ${school.category}`}>
                          {school.category.toUpperCase()}
                        </span>
                      </div>
                      
                      <div className={`chance-column ${getChanceColorClass(school.admission_chances)}`}>
                        {school.old_admission_chances !== undefined &&
                         school.old_admission_chances !== null &&
                         school.old_admission_chances !== school.admission_chances ? (
                          <span className="chance-comparison">
                            <span className="old-chance">{school.old_admission_chances}%</span>
                            <span className="arrow">→</span>
                            <span className={`new-chance ${getChangeClass(school.old_admission_chances, school.admission_chances)}`}>
                              {school.admission_chances}%
                            </span>
                          </span>
                        ) : (
                          <span>{school.admission_chances ? `${school.admission_chances}%` : 'N/A'}</span>
                        )}
                      </div>

                      <div className="acceptance-rate-column">
                        {school.acceptance_rate ? `${school.acceptance_rate}%` : 'N/A'}
                      </div>

                      <div className="actions-column">
                        {linkUrl && (
                          <a
                            href={linkUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="action-btn-icon link"
                            title="More Information"
                          >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                              <polyline points="15 3 21 3 21 9" />
                              <line x1="10" y1="14" x2="21" y2="3" />
                            </svg>
                          </a>
                        )}
                        <button
                          className="action-btn-icon delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            onRemoveFromSaved(school.id);
                          }}
                          title="Remove from saved"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      )}
    </section>
  );
}

export default SavedColleges;